import i18n from '@sprinklr/display-builder/i18n';
import { TimePeriodKey } from 'models/TimePeriod/TimePeriod';

export const TIME_PERIOD_PICKER_OPTIONS: Array<{
    id: TimePeriodKey;
    name: string;
    period?: string;
    label?: string;
}> = [
    {
        id: 'last_60_minutes',
        name: i18n.t('Last 60 Minutes'),
    },
    {
        id: 'today',
        name: i18n.t('Today'),
    },
    {
        id: 'yesterday',
        name: i18n.t('Yesterday'),
    },
    {
        id: 'last_12_hours',
        name: i18n.t('Last ${hours} Hours', { hours: 12 }),
        period: 'this Hour',
    },
    {
        id: 'last_24_hours',
        name: i18n.t('Last ${hours} Hours', { hours: 24 }),
        period: 'this Hour',
    },
    {
        id: 'this_week',
        name: i18n.t('This Week'),
    },
    {
        id: 'last_week',
        name: i18n.t('Last Week'),
    },
    {
        id: 'last_7_days',
        name: i18n.t('Last ${days} Days', { days: 7 }),
        period: 'Today',
    },
    {
        id: 'this_month',
        name: i18n.t('This Month'),
    },
    {
        id: 'last_month',
        name: i18n.t('Last Month'),
    },
    {
        id: 'last_28_days',
        name: i18n.t('Last ${days} Days', { days: 28 }),
        period: 'Today',
    },
    {
        id: 'last_30_days',
        name: i18n.t('Last ${days} Days', { days: 30 }),
        period: 'Today',
    },
    {
        id: 'last_60_days',
        name: i18n.t('Last ${days} Days', { days: 60 }),
        period: 'Today',
    },
    {
        id: 'last_90_days',
        name: i18n.t('Last ${days} Days', { days: 90 }),
        period: 'Today',
    },
    {
        id: 'last_120_days',
        name: i18n.t('Last ${days} Days', { days: 120 }),
        period: 'Today',
    },
    {
        id: 'last_180_days',
        name: i18n.t('Last ${days} Days', { days: 180 }),
        period: 'Today',
    },
    {
        id: 'year_to_date',
        name: i18n.t('Year to Date'),
    },
    {
        id: 'this_year',
        name: i18n.t('This Year'),
    },
    {
        id: 'last_year',
        name: i18n.t('Last Year'),
    },
    {
        id: 'next_week',
        name: i18n.t('Next Week'),
    },
    {
        id: 'last_365_days',
        name: i18n.t('Last ${days} Days', { days: 365 }),
        period: 'Today',
    },
    {
        id: 'last_x_months',
        name: i18n.t('Last X Months'),
        period: 'This Month',
        label: 'Months',
    },
    {
        id: 'last_x_weeks',
        name: i18n.t('Last X Weeks'),
        period: 'This Week',
        label: 'Weeks',
    },
    {
        id: 'last_x_hours',
        name: i18n.t('Last X Hours'),
        period: 'This Hour',
        label: 'Hours',
    },
    {
        id: 'last_x_minutes',
        name: i18n.t('Last X Minutes'),
        period: 'This Minute',
        label: 'Minutes',
    },
    {
        id: 'custom_duration',
        name: i18n.t('Custom Days'),
        period: 'Today',
    },
    {
        id: 'x_days_ago',
        name: i18n.t('X Days Ago'),
        label: 'Days Ago',
    },
    {
        id: 'x_weeks_ago',
        name: i18n.t('X Weeks Ago'),
        label: 'Weeks Ago',
    },
    {
        id: 'x_months_ago',
        name: i18n.t('X Months Ago'),
        label: 'Months Ago',
    },
    {
        id: 'x_quarters_ago',
        name: i18n.t('X Quarters Ago'),
        label: 'Quarters Ago',
    },
    {
        id: 'custom',
        name: i18n.t('Custom Date Range'),
    },
    {
        id: 'custom_to_date',
        name: i18n.t('Custom Date Through Today'),
    },
];

export const DAY_IN_MS = 24 * 3600 * 1000;
